import { createRouter, createWebHistory } from "vue-router";

import HomePage from "../views/HomePage.vue";
import SlotPage from '../views/SlotPage.vue';
import SlotPageDetail from '../views/SlotPageDetail.vue'
import ContactPage from '../views/ContactPage.vue'
import AboutUs from '../views/AboutUs.vue'
import CarrerWithUs from '../views/CarrerWithUs.vue'
import CookiePage from "../views/CookiePage.vue"
import OurSolution from "../views/OurSolutions.vue"
import PageNotFound from '../views/PageNotFound.vue'


const routes = [
  {
    path: "/:lang?",
    name: "HomePage",
    component: HomePage,
  },
  {
    path: "/:lang?/about-us",
    name: "AboutUs",
    component: AboutUs,
  },
  {
    path: "/:lang?/games",
    name: "slotGame",
    component: SlotPage
  },
  {
    path: "/:lang?/contact",
    name: "contactPage",
    component: ContactPage,
  },
  {
    path: "/:lang?/gameDetail/:id?/:token?/:currency?/:language?",
    props: true,
    name: "slotPage-Detail",
    component: SlotPageDetail,
  },
  {
    path: "/:lang?/careers",
    name: "CarrerWithUs",
    component: CarrerWithUs,
  },
  {
    path: "/:lang?/cookie",
    name: "Cookie_Page",
    component: CookiePage,
  },
  {
    path: "/:lang?/solutions",
    name: "OurSolutions_Page",
    component: OurSolution,
  },
  {
    path: "/:pathMatch(.*)*",
    name: "PageNotFound",
    component: PageNotFound,
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior() {
    return { top: 0 };
  },
});

export default router;
